import script from "./form-category.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-category.vue?vue&type=script&setup=true&lang=ts"

import "./form-category.vue?vue&type=style&index=0&id=74142e4f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74142e4f"]])

export default __exports__